module.exports = __webpack_public_path__ + "media/packs/images/flags/KH-64b53227c3cebdabd30fb71f1d7c858d.png";